import { render, staticRenderFns } from "./NextBtnGray.vue?vue&type=template&id=bbc8fa2e&scoped=true"
import script from "./NextBtnGray.vue?vue&type=script&lang=js"
export * from "./NextBtnGray.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc8fa2e",
  null
  
)

export default component.exports